// extracted by mini-css-extract-plugin
export var aiStarIcon = "_bn-4";
export var closeButton = "_bn-6";
export var dismissButton = "_bn-3";
export var editImageWithAiContainer = "_bn-8";
export var imageUploadWrapper = "_bn-7";
export var misspelledWord = "_bn-5";
export var spellCheckContainer = "_bn-2";
export var spin = "_bn-1";
export var spinning = "_bn-0";